import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.74906 16.0017H14.2509M8.6236 12.5002H15.3764M7.49813 8.99875H16.5019M18.3667 5.63335C21.8831 9.14982 21.8831 14.8502 18.3667 18.3667C14.8502 21.8831 9.14982 21.8831 5.63335 18.3667C2.11689 14.8502 2.11689 9.14982 5.63335 5.63335C9.14982 2.11689 14.8502 2.11689 18.3667 5.63335Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgMenuCircle);
export default ForwardRef;
